"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXCLUDED_ITEM_STATUSES = exports.LOYALTY_EARNING_TYPE_MAP = exports.LOYALTY_REWARD_TYPE_MAP = void 0;
const enums_1 = require("../enums");
exports.LOYALTY_REWARD_TYPE_MAP = {
    [enums_1.RewardType.DISCOUNT_ENTIRE_SALE]: 'RewardByDiscountEntireSale',
    [enums_1.RewardType.PRODUCT_DISCOUNT]: 'RewardByDiscountProduct',
    [enums_1.RewardType.FREE_ITEM]: 'RewardByFreeItem',
};
exports.LOYALTY_EARNING_TYPE_MAP = {
    [enums_1.EarningType.EARN_BY_AMOUNT]: 'EarnByAmount',
    [enums_1.EarningType.EARN_BY_PURCHASE_ITEM]: 'EarnByPurchaseItem',
};
exports.EXCLUDED_ITEM_STATUSES = [
    enums_1.OrderItemStatus.VOID,
    enums_1.OrderItemStatus.CANCELLED,
];
//# sourceMappingURL=loyalty.js.map